import combine from "../services/combine-service";

const materials = {
  all: [],
  vendors: []
};
export default function(state = materials, action) {
  var payload;
  switch (action.type) {
    case "dailymaterialentries - materials":
      return {
        ...state,
        all: action.payload
      };
      break;
    case "Update > dailymaterialentries":
      let oldlength = state.all.length;
      let newmats = combine(
        state.all,
        action.payload,
        "id",
        action.deletestatus
      );
      console.log("material diff", newmats.length - oldlength);
      return {
        ...state,
        all: newmats
      };
      break;
    case "materials - materials":
      return { ...state, vendors: action.payload };
      break;
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/materials-reducer.js